import React, { useRef, useState } from "react";
import { Box, HStack, IconButton, Text } from "@chakra-ui/react";
import { FiPause, FiPlay } from "react-icons/fi";

export default function PodcastCard({ episode }) {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const toggle = () => {
    if (!audioRef.current) return;
    if (playing) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setPlaying(!playing);
  };

  const created = episode.created_at
    ? new Date(episode.created_at).toLocaleDateString()
    : "";

  return (
    <Box
      borderWidth="1px"
      borderColor="border.default"
      borderRadius="md"
      p={3}
      bg="surface.card"
    >
      <HStack spacing={3} align="center">
        {episode.audio_url && (
          <IconButton
            icon={playing ? <FiPause /> : <FiPlay />}
            size="sm"
            aria-label={playing ? "Pause" : "Play"}
            onClick={toggle}
            colorScheme="gwbi"
            variant="outline"
          />
        )}
        <Box flex="1" minW={0}>
          <Text fontWeight="semibold" fontSize="sm" noOfLines={1}>
            {episode.title || "Untitled episode"}
          </Text>
          <Text fontSize="xs" color="text.muted">
            {episode.voice && `${episode.voice} · `}
            {created}
          </Text>
        </Box>
      </HStack>
      {episode.audio_url && (
        <audio
          ref={audioRef}
          src={episode.audio_url}
          onEnded={() => setPlaying(false)}
          style={{ display: "none" }}
        />
      )}
    </Box>
  );
}
